import React from 'react'
import { Route, Routes } from 'react-router-dom'

import Home from './InnerPages/Home'
import AboutUs from './InnerPages/AboutUs'
import Offers from './InnerPages/Offers'
import ContactUs from './InnerPages/ContactUs'
import Admin from './Admin/Admin'
import Register from './Admin/Register'
import AdminDashboard from './Admin/AdminDashboard'


import AddOffer from './Admin/AddOffer'
import DeleteOffer from './Admin/DeleteOffer'
import EditOffer from './Admin/EditOffer'

import AddTreatment from './Admin/AddTreatment'
import DeleteTreatment from './Admin/DeleteTreatment'
import EditTreatment from './Admin/EditTreatment'
import Treatments from './InnerPages/Treatments'
import BookAppointment from './InnerPages/BookAppointment'
import AddLocation from './Admin/AddLocation'
import DeleteLocation from './Admin/DeleteLocation'
import EditLocation from './Admin/EditLocation'
import AddDoctor from './Admin/AddDoctor'
import DeleteDoctor from './Admin/DeleteDoctor'
import EditDoctor from './Admin/EditDoctor'
import BookAppointmentData from './Admin/BookAppointmentData'
import ForgotPassword from './Admin/ForgotPassword'
import ResetPassword from './Admin/ResetPassword'
import ResetEmailPassword from './Admin/ResetEmailPassword'
import SubTreatments from './InnerPages/SubTreatments '
import SubLocation from './InnerPages/SubLocation'
import SubDoctor from './InnerPages/SubDoctor'
import SubDoctorQualification from './InnerPages/SubDoctorQualification'
const Routing = () => {
  return (
    <Routes>

      <Route path='/' element={<Home />} />
      <Route path='/aboutus' element={<AboutUs />} />
      <Route path='/treatments' element={<Treatments />} />
      <Route path='/subtreatments' element={<SubTreatments />} />
      <Route path='/sublocation' element={<SubLocation />} />
      <Route path='/subdoctor' element={<SubDoctor />} />
      <Route path='/subdoctorqualification' element={<SubDoctorQualification />} />

       
      <Route path='/bookappointment' element={<BookAppointment />} />
      <Route path='/offers' element={<Offers />} />
      <Route path='/contactus' element={<ContactUs />} />
      <Route path='/admin' element={<Admin />} />
      <Route path='/register' element={<Register />} />

      <Route path='/admindashboard' element={<AdminDashboard />} >
        <Route path='' element={<AddTreatment />} />
        <Route path='deletetreatment' element={<DeleteTreatment />} />
        <Route path='addlocation' element={<AddLocation />} />
        <Route path='deletelocation' element={<DeleteLocation />} />
       <Route path='adddoctor' element={<AddDoctor />} />
        <Route path='deletedoctor' element={<DeleteDoctor />} />

        <Route path='addoffer' element={<AddOffer />} />
        <Route path='deleteoffer' element={<DeleteOffer />} />
        <Route path='bookappointmentdata' element={<BookAppointmentData />} />


      </Route>

       <Route path='/forgotpassword' element={<ForgotPassword/>}/>
       <Route path='/resetpassword' element={<ResetPassword/>}/>
       <Route path='/resetemailpassword/:uuname' element={<ResetEmailPassword/>}/>

       
       

      <Route path='/edittreatment/:tid' element={<EditTreatment />} />
      <Route path='/editlocation/:sid' element={<EditLocation/>} />
      <Route path='/editoffer/:sid' element={<EditOffer />} />
    <Route path='/editdoctor/:sid' element={<EditDoctor/>}/>

    </Routes>
  )
}

export default Routing